import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export function PageHeader({ title, onBack, right }) {
  const navigate = useNavigate();
  return (
    <div className="flex items-center gap-3 mb-5">
      <button data-testid="page-back-button" onClick={() => (onBack ? onBack() : navigate(-1))}
        className="w-10 h-10 rounded-full bg-surface2 flex items-center justify-center hover:bg-brand-soft transition-colors">
        <ArrowLeft size={20} className="text-ink" />
      </button>
      {title ? <h1 className="font-display text-2xl text-ink tracking-tight flex-1 truncate">{title}</h1> : <div className="flex-1" />}
      {right}
    </div>
  );
}
